import { Subscription } from "rxjs";

export class SubscriptionManager {
    private subscriptionsMap: Map<number, Subscription> = new Map<number, Subscription>();

    private _counter: number = 0;
    

    addSubscription(subscription: Subscription): number {
        const subscriptionId = this.generateUniqueId();
        this.subscriptionsMap.set(subscriptionId, subscription);
        return subscriptionId;
    }

    removeSubscription(subscriptionId: number): void {
        const subscription = this.subscriptionsMap.get(subscriptionId);
        if (subscription) {
            subscription.unsubscribe();
            this.subscriptionsMap.delete(subscriptionId);
        }
    }

    generateUniqueId(): number {
        return this._counter++;
    }
}

